/**
 * Shared DOM utilities.
 *
 * Extracted from useCanvas.ts, useOrchestration.ts, and useObserver.ts
 * to eliminate duplication.
 */

/** Strip HTML tags to plain text using DOMParser */
export const stripHtml = (html: string): string => {
  if (!html) return ''
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.textContent || ''
}
